export { Text } from '@mantine/core'
